module.exports = __webpack_public_path__ + "static/img/img_cabinet.bf1f9ff2.png";